// extracted by mini-css-extract-plugin
export default {"canvas":"Canvas_canvas__5cvDR","canvasDiv":"Canvas_canvasDiv__Fsmof","onionImage":"Canvas_onionImage__hv+DA","exportImage":"Canvas_exportImage__S6376"};